import { createTheme } from '@mui/material/styles';
import { grey, red } from '@mui/material/colors';

// Define color variables
const ChetwodeBlue = '#484DB5'; // Custom button color
const ChetwodeBlueDark = '#3c4f9a'; // Darker shade for hover or focus
const whiteColor = '#ffffff'; // White for contrast
const brightBlue = '#007bff'; // Bright blue for primary
const greyColor = '#6c757d'; // Grey for secondary elements
const lightBackground = '#ffffff'; // Pure white background
const lightPaper = '#f5f5f5'; // Light grey for elements
const blackColor = '#000000'; // Black for high contrast text
const darkBackground = '#121212'; // Very dark background
const darkPaper = '#333333'; // Slightly lighter dark grey for elements
const lightBlue = '#1e90ff'; // Light blue for dark backgrounds
const tomatoRed = '#ff6347'; // Tomato red for secondary elements
const lightErrorRed = red[300]; // Light red for error messages

// Common Typography
const typography = {
  fontSize: 12,
  fontWeightRegular: 400,
  fontWeightBold: 700,
  h1: {
    fontSize: '12.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.3,
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 700,
    lineHeight: 1.4,
  },
  fontFamily: "'Inter', sans-serif",
};

// Light Theme
export const lightTheme = createTheme({
  palette: {
    primary: {
      main: brightBlue, // Bright blue
      contrastText: whiteColor,
    },
    secondary: {
      main: greyColor, // Grey for secondary elements
      contrastText: whiteColor,
    },
    buttonColor: {
      main: ChetwodeBlue, // Custom button color
      dark: ChetwodeBlueDark, // Darker shade for hover
      contrastText: whiteColor, // White text for contrast
    },
    background: {
      default: lightBackground, // Pure white background
      paper: lightPaper, // Light grey for elements
    },
    text: {
      primary: blackColor, // Black text for high contrast
      secondary: grey[700], // Slightly lighter grey for secondary text
    },
    error: {
      main: red[500], // Red for error messages
    },
  },
  typography,
  spacing: 8, // Consistent spacing
});

// Dark Theme
export const darkTheme = createTheme({
  palette: {
    primary: {
      main: lightBlue, // Light blue for dark backgrounds
      contrastText: whiteColor,
    },
    secondary: {
      main: tomatoRed, // Tomato red for secondary elements
      contrastText: whiteColor,
    },
    buttonColor: {
      main: ChetwodeBlue, // Custom button color
      dark: ChetwodeBlueDark, // Darker shade for hover
      contrastText: whiteColor, // White text for contrast
    },
    background: {
      default: darkBackground, // Very dark background
      paper: darkPaper, // Slightly lighter dark grey for elements
    },
    text: {
      primary: whiteColor, // White text for high contrast
      secondary: grey[400], // Lighter grey for secondary text
    },
    error: {
      main: lightErrorRed, // Light red for error messages
    },
  },
  typography,
  spacing: 8, // Consistent spacing
});
